<template>
</template>

<script>
export default {
  name: 'pagenotfound',
  mounted(){
    window.location.href = "/static/404.html"
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/router/pagenotfound.vue